export const MAX_CRUISE_STAYS = 20;
export const MAX_CRUISE_DEPARTURE_DATE_RANGE_DAYS = 90;
export const MAX_NUMBER_OF_CABINS = 9;
export const MAX_ADULTS = 10;
export const DEFAULT_ADULTS = 2;
export const MAX_CHILDREN = 10;
export const MAX_AGE_OF_CHILDREN = 12;
